import { Trans, useTranslation } from 'react-i18next';

import type { AssetFamily } from '~/modules/artist-roster/lib/types';

import { ContributorLinks } from './ContributorLinks';

interface TrackTableParticipantsCellProps {
  asset: AssetFamily;
}

export function TrackTableParticipantsCell({
  asset: { contributors },
}: TrackTableParticipantsCellProps) {
  const { t } = useTranslation('roster');

  return (
    <div className="flex flex-col px-sm">
      <div>
        <Trans
          t={t}
          i18nKey="trackList.contributors.mainArtists"
          components={{
            strong: <span className="font-semibold" />,
            Artists: (
              <ContributorLinks {...{ contributors, type: 'PRIMARY_ARTIST' }} />
            ),
          }}
        />
      </div>
      <div>
        <Trans
          t={t}
          i18nKey="trackList.contributors.featuredArtists"
          components={{
            strong: <span className="font-semibold" />,
            Artists: (
              <ContributorLinks
                {...{ contributors, type: 'FEATURED_ARTIST' }}
              />
            ),
          }}
        />
      </div>
    </div>
  );
}

TrackTableParticipantsCell.displayName = 'TrackTableParticipantsCell';
